export const API_ENDPOINT = "https://api-skaitemplate.dgc-dev.com/api/";
// export const API_ENDPOINT = "https://localhost:44379/api/";

// export const APP_ID = 'c995549f-a608-48d3-8d68-057c39e8ee02';
// export const APP_URL = 'https://admin-addin-skaitemplate.dgc-dev.com/';

// Local
export const APP_ID = '8cb6669f-2435-41c6-8c8e-a84ef81ea61b';
export const APP_URL = 'https://localhost:3000/';
export const DOMAIN = 'CTCam.onmicrosoft.com';

export const API_SCOPES = ['api://f38f9215-825a-41b0-858d-1811eef62007/ReadWrite.All'];

export const FONT_LINK = "http://www.khmerfonts.info/";

export const HEADER_CONFIG = {
  headers: {
    "Content-Type": "application/json",
    Authorization: ""
  }
};